import { picklistAction } from "./../actions/types";

export default function reducer(state = [], action) {
  switch (action.type) {
    case picklistAction.FETCH_PICKLISTS:
      return { ...state, pickLists: action.payload };
    case picklistAction.FETCH_PICKLISTS_LIMIT:
      return { ...state, pickListsLimit: action.payload };
    case picklistAction.FETCH_PICKLISTS_BY_CODE:
      return { ...state, pickListsByCode: action.payload };
    case picklistAction.FETCH_PICKLIST_CODES:
      return { ...state, pickListCodes: action.payload };
    default:
      return state;
  }
}
